import type { ProductBox } from "@gatsby-plugin-generic-page/types/productBoxTypes"
import isEmpty from "~/lib/isEmpty"

export default function hasAnyOuterFooter(boxes: ProductBox[]): boolean {
  return boxes.some((box) => !isEmpty(box.flatData.outerFooter))
}
